module.exports = __webpack_public_path__ + "img/checkbox-blank.3f815d73.svg";